
var
analitycsService = (function(){
  var
    _dataLayer = [],
    _catalog = ((typeof $catalog !== 'undefined') && $catalog.length > 0) ? $catalog : [];

  function init() {
    _log('analitycsWidget init', true);
    _setUpListners();
  }

  function _setUpListners() {
  }

  function _findCatalogItem(itemCart) {
    _log('itemCart', itemCart);
    for (var index = 0; index < _catalog.length; index++) {
      for (var indexItem = 0; indexItem < _catalog[index].childs.length; indexItem++) {
        if (parseInt(_catalog[index].childs[indexItem].nomenclature.id) === parseInt(itemCart.nid)) {
          _log('catalogItem', _catalog[index]);
          _log('catalogItemChild', _catalog[index].childs[indexItem]);
          _catalog[index].childs[indexItem]['category_title'] = _catalog[index].category_title;
          return _catalog[index].childs[indexItem];
        }
      }
    }
  }

  function addToCart(itemCart) {
    var _catalogItem = _findCatalogItem(itemCart);
    var _data = {
      'event': 'addToCart',
      'ecommerce': {
        'currencyCode': 'RUB',
        'add': {                                // 'add' actionFieldObject measures.
          'actionField': {'step': 1},
          'products': [{                        //  adding a product to a shopping cart.
            'name': _catalogItem.title,
            'id': _catalogItem.nomenclature.id,
            'price': parseFloat(_catalogItem.artikuls.price),
            'brand': 'Экспресс суши',
            'category': _catalogItem.category_title,
            'variant': 'default',
            'quantity': itemCart.a
          }]
        }
      }
    };
    _log('addToCart/_data', _data);
    _dataLayer = [];
    _dataLayer.push(_data);
    return _dataLayer;

  }

  function addToCartGA(itemCart) {
    var
      _catalogItem = _findCatalogItem(itemCart),
      _item = {
        'id': _catalogItem.nomenclature.id,
        'name': _catalogItem.title,
        'category': _catalogItem.category_title,
        'brand': 'Экспресс суши',
        'variant': 'default',
        'price': parseFloat(_catalogItem.artikuls.price),
        'quantity': itemCart.a
      };
    if (typeof ga == 'function') {
      ga('ec:addProduct', _item);
      ga('ec:setAction', 'add', {
        'step': 1
      });
      ga('send', 'event', 'UX', 'click', 'add to cart'); // Send data using an event.
    } else {
      console.error('function ga undefined');
    }

    if (typeof gtag == 'function') {
      gtag('event', 'add_to_cart', {
        "items": [
          _item
        ]
      });
    } else {
      console.error('function gtag undefined');
    }
  }

  function removeFromCart(itemCart) {
    var _catalogItem = _findCatalogItem(itemCart);
    var _data = {
      'event': 'removeFromCart',
      'ecommerce': {
        'remove': {                                // 'add' actionFieldObject measures.
          'products': [{                        //  adding a product to a shopping cart.
            'name': _catalogItem.title,
            'id': _catalogItem.nomenclature.id,
            'price': parseFloat(_catalogItem.artikuls.price),
            'brand': 'Экспресс суши',
            'category': _catalogItem.category_title,
            'variant': 'default',
            'quantity': itemCart.a
          }]
        }
      }
    };
    _log('removeFromCart/_data', _data);
    _dataLayer = [];
    _dataLayer.push(_data);
    return _dataLayer;
  }

  function removeFromCartGA(itemCart) {
    var
      _catalogItem = _findCatalogItem(itemCart),
      _item = {
        'id': _catalogItem.nomenclature.id,
        'name': _catalogItem.title,
        'category': _catalogItem.category_title,
        'brand': 'Экспресс суши',
        'variant': 'default',
        'price': parseFloat(_catalogItem.artikuls.price),
        'quantity': itemCart.a
      };
    console.log('_item', _item);
    if (typeof ga == 'function') {
      ga('ec:addProduct', _item);
      ga('ec:setAction', 'remove');
      ga('send', 'event', 'UX', 'click', 'remove from cart');     // Send data using an event.
    } else {
      console.error('function ga undefined');
    }

    if (typeof gtag == 'function') {
      gtag('event', 'remove_from_cart', {
        "items": [
          _item
        ]
      });
    } else {
      console.error('function gtag undefined');
    }
  }

  function _transaction( data) {
    // return _dataLayer.push({
    //   event: 'transaction',
    //   ecommerce: data
    // });
  }

  return {
    init: init,
    dataLayer: _dataLayer,
    addToCart: addToCart,
    addToCartGA: addToCartGA,
    removeFromCart: removeFromCart,
    removeFromCartGA: removeFromCartGA,
  };

})(); // => END analitycsService

window.addEventListener('load', function(){
  analitycsService.init();
});
var
basket = (function(){
  var _data,
    _item = $('.basket-item');

  function init() {
    _load();
    _setUpListners();
  }

  function _setUpListners() {
  }

  function _load() {
    return sendData(
        'old=true',
        '/api/v1/baskets',
        'GET'
      )
      .done(function(data) {
        _data = data;
        console.log('apiBasket', _data);
        storage.set('basket', JSON.stringify(_data));
      })
      .fail(function(data) {
        console.log('Ошибка при загрузке корзины:', data);
      });
  }

  function update() {
    _load()
      .done(function() {
        _updateData(_data);
      });
  }

  function _updateData(data) {
    var _selectShop = cookie.getShop();
    $(_item).each(function(i, item) {
      var
        _block = $(item),
        _calcBtn = _block.find('.calc'),
        _input = _block.find('._amount[data-type="main"]');
      if (_input.length) {
        var
          _inputNom = parseInt(_input.data('nomid')),
          _targetData = data[_inputNom];

        console.log('_input', _input);
        // console.log('_inputNom', _inputNom);
        // console.log('_targetData', _targetData);

        if (_targetData.artikuls == undefined || _targetData.artikuls[_selectShop] == undefined || _targetData == undefined) {
          // _input.hide();
          _input.parents('.basket-item').hide();
        }
        else {

          var
            cart = ($.cookie('cart') === undefined) ? {} : JSON.parse($.cookie('cart')),
            itemCart = {};

          itemCart = {
            id: parseInt(_targetData.artikuls[_selectShop].artikul_id),
            nid: parseInt(_targetData.nomid),
            cat: parseInt(_targetData.category_id),
            pp: parseInt(_targetData.porpack),
            ps: parseInt(_targetData.porstep),
            sid: _selectShop,
            p: parseInt(_targetData.artikuls[_selectShop].price),
            s: 1,
            t: "main",
            a: parseInt(_targetData.amount),
            d: parseInt(_targetData.delivery)
          };
          cart[_targetData.nomid] = itemCart;

          $total = calculateCart(cart);

          $.when( packingStatus.check() ).done(function(){
            $total = calculateCart(cart);
          });

          widgetCart.updateItem($("#in_cart_" + parseInt(_targetData.artikuls[_selectShop].artikul_id)), itemCart);

          // Обновляем страницу при смене магазина // Пока так...
          _calcBtn
            .data('artikul', _targetData.artikuls[_selectShop].artikul_id)
            .attr('data-artikul', _targetData.artikuls[_selectShop].artikul_id);
          _block
            .attr('id', 'in_cart_'+ _targetData.artikuls[_selectShop].artikul_id)
            .find('._pbp')
            .attr('id', 'pbp_'+ _targetData.artikuls[_selectShop].artikul_id)
            .html(parseInt(_targetData.amount) * parseInt(_targetData.artikuls[_selectShop].price));
          _input
            .attr('data-shopid', _selectShop)
            .data('shopid', _selectShop)
            .attr('data-artikul', _targetData.artikuls[_selectShop].artikul_id)
            .data('artikul', _targetData.artikuls[_selectShop].artikul_id)
            .attr('data-price', _targetData.artikuls[_selectShop].price)
            .data('price', _targetData.artikuls[_selectShop].price)
            .attr('id', _targetData.artikuls[_selectShop].artikul_id);

          _input.show();
        }
      }
      // return false;
    });
  }

  return {
    init: init,
    update: update
  };
})(); // => END basket

$(function() {
  // Корзина
  if($('.basket-items').length) {
    basket.init();
  }
});
var cookie = (function(){

  function init() {
    return true;
  }

  function _getShop() {
    return ($.cookie('shop') === undefined) ? 0 : parseInt($.cookie('shop'));
  }

  function _setShop(_id) {
    _id = parseInt(_id);
    if (_id == 0) {
      $.cookie('shop', null, { expires: -1, path: '/' });
    } else {
      $.cookie('shop', JSON.stringify(_id), { expires: _expires, path: '/' });
    }
    $('[name="shops_id"]')
      .val(_id)
      .attr('value', _id)
      .trigger("input");
  }

  function _getCart() {
    return ($.cookie('cart') === undefined) ? {} : JSON.parse($.cookie('cart'));
  }

  function _setCart(_cart) {
    $.cookie('cart', JSON.stringify(_cart), { expires: _expires, path: '/' });
  }

  function _clear(_key) {
    $.cookie(_key, null, { expires: -1, path: '/' });
  }

  return {
    init: init,
    getShop: _getShop,
    setShop: _setShop,
    getCart: _getCart,
    setCart: _setCart,
    clear: _clear
  };
})(); // => END cookie
var
deliveryZone = (function(){
  var
    $deliveryZone = $('#deliveryZone'),
    _mapCenter = $centerDelivery,
    _polygonData = $polygonDelivary,
    $checkDeliveryAddress = $('.check-delivery-address'),
    $checkDeliveryAddressInput = $('.check-delivery-address').find('._input'),
    $checkDeliveryAddressCheck = $('.check-delivery-address').find('._check');

  function init() {
    _setUpListners();
    _showMap();
  }

  function _setUpListners() {
    if($checkDeliveryAddressCheck.length > 0) {
      $checkDeliveryAddressCheck.on('click', _check);
    } else {
      $checkDeliveryAddressInput.on('change', _check);
    }
  }

  function _check() {
    var _address = $('.check-delivery-address').find('._input').val().split(' ').join('+');

    if($.trim($('.check-delivery-address').find('._input').val().toLowerCase()) === '') {
      return false;
    }

    return sendData(
        'apikey=7fa9d55a-29ac-461d-b383-8e47ecb0f074'+
        '&format=json'+
        '&rspn=1'+
        '&ll=73.375683418,54.9840141639'+
        '&spn=0.5,1'+
        '&geocode='+ _address,
        'https://geocode-maps.yandex.ru/1.x/',
        'GET'
      )
      .done(function(data) {
        var
          _data = data,
          _coords = (!isEmpty(_data.response.GeoObjectCollection.featureMember))? _data.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos: null;
        console.log('Ваш адрес в зоне доставки:', _coords);

        return sendData(
            JSON.stringify({
              coords: _coords
            }),
            '/order/check_address',
            'POST'
          )
          .done(function(res) {
            var _resultBlock = $('.check-delivery-address-result');
            if(res.result) {
              $('[name="dz"]').val(1);
              _resultBlock.removeClass('text-danger').addClass('text-success').html('Ваш адрес в зоне доставки');
            } else {
              $('[name="dz"]').val(0);
              _resultBlock.removeClass('text-success').addClass('text-danger').html('Либо вы ввели не верный адрес, либо ваш адрес не входит в зону доставки, но вы можете оформить заказ на самовывоз.');
            }
          })
          .fail(function(res) {
            console.log('Ошибка при загрузке:', res);
          });

        // storage.set('geocode', JSON.stringify(_data));
      })
      .fail(function(data) {
        console.log('Ошибка при загрузке:', data);
      });
  }

  function _showMap() {
    $(function() {
      var $deliveryZone = $('#deliveryZone');
      $deliveryZone.css({ height: (($deliveryZone.attr('data-height'))? $deliveryZone.attr('data-height') : 400) });
      var
        myMap = new ymaps.Map("deliveryZone", {
          center: _mapCenter,
          zoom: (($deliveryZone.attr('data-zoom'))? $deliveryZone.attr('data-zoom') : 10),
          controls: []
        }),
        _map = myMap;

      myMap.controls.add(
        new ymaps.control.ZoomControl()
      );

      (function() {
        var myPolygon = new ymaps.Polygon(
          [_polygonData],
          {
            hintContent: "Зона доставки от 60 до 90 минут"
          },
          {
            fillColor: "#1bad03",
            strokeColor: "#1bad03",
            opacity: 0.35,
            strokeWidth: 5,
            zIndex: 100,
            zIndexHover: 100
          });
        myPolygon.options.setParent(_map.options);
        _map.geoObjects.add(myPolygon);
        myPolygon.events.add("mouseenter", function() {
          //myPolygon.options.set("opacity", 0.99);
        });
        myPolygon.events.add("mouseleave", function() {
          //myPolygon.options.set("opacity", 0.99);
        });
      })();
    });
  }

  return {
    init: init,
    check: _check
  };
})(); // => END deliveryZone

window.onload = function() {
  if ($('#deliveryZone').length > 0) {
    // $('#deliveryZone').before('<div class="input-group mb-3 check-delivery-address">'+
    //     '<input type="text" class="form-control _input" placeholder="Проверьте, входит ли ваш адрес в зону доставки" aria-label="Проверьте, входит ли ваш адрес в зону доставки" aria-describedby="button-addon2" value="">'+
    //     '<div class="input-group-append">'+
    //       '<button class="btn btn-primary _check" type="button" id="button-addon2">Проверить</button>'+
    //     '</div>'+
    //   '</div>');
    if($('.check-delivery-address').length) {
      $('.check-delivery-address').after('<p class="check-delivery-address-result"></p>');
      $('.check-delivery-address ._suggest').selectize({
        valueField: 'value',
        labelField: 'displayName',
        searchField: 'value',
        maxItems: 1,
        options: [
        ],
        create: false,
        render: {
          option: function(item, escape) {
            if ((item.value).indexOf('подъезд') != -1 || (item.value).indexOf('поселок') != -1) {
              return '<div></div>';
            } else {
              return '<div>' +
                '<span class="item">' +
                    '<span class="displayName">' + escape(item.displayName) + '</span>' +
                '</span>' +
            '</div>';
            }
          }
        },
        load: function(query, callback) {
          if (!query.length) return callback();
          if (query.length > 2) {
            ymaps.suggest(query, {
              boundedBy: [
                [55.072368295297736,73.22462140628126],
                [54.913664608084616,73.49927960940622]
              ],
              results: 30
            })
              .done(function(res) {
                callback(res);
              });
          }
        }
      });
    }
    deliveryZone.init();
  }

};
"use strict";

var
metrikaService = (function(){

  var
    $itemsCart = [],
    _dataLayer = [],
    _catalog = ((typeof $catalog !== 'undefined') && $catalog.length > 0) ? $catalog : [];

  function init() {
    _log('metrikaService init', true);
    _setUpListners();
  }

  function _setUpListners() {
  }

  function reachGoal(_ID, _TARGET) {
    if (typeof ym == 'function') {
      ym(_ID, 'reachGoal', _TARGET);
    }

    _log('reachGoal', _TARGET);
    return true;
  }

  function _findCatalogItem(itemCart) {
    _log('itemCart', itemCart);
    for (var index = 0; index < _catalog.length; index++) {
      for (var indexItem = 0; indexItem < _catalog[index].childs.length; indexItem++) {
        if (parseInt(_catalog[index].childs[indexItem].nomenclature.id) === parseInt(itemCart.nid)) {
          _log('catalogItem', _catalog[index]);
          _log('catalogItemChild', _catalog[index].childs[indexItem]);
          _catalog[index].childs[indexItem]['category_title'] = _catalog[index].category_title;
          return _catalog[index].childs[indexItem];
        }
      }
    }
  }

  function addToCart(itemCart) {
    console.info('metrikaService.addToCart');
    _log('metrikaService.addToCart.itemCart', itemCart);
    dataLayer.push({
      "ecommerce": {
        "currencyCode": "RUB",
        "add": {
          "products": [
            {
              "id": (itemCart.id).toString(),
              "name": (itemCart.name).toString(),
              "price": itemCart.price,
              "brand": "Компания «Здоровье»",
              "category": itemCart.category,
              "quantity": itemCart.quantity
            }
          ]
        }
      }
    });

    return true;
  }

  function removeFromCart(itemCart) {
    console.info('metrikaService.removeFromCart');
    _log('metrikaService.removeFromCart.itemCart', itemCart);
    dataLayer.push({
      "ecommerce": {
        "currencyCode": "RUB",
        "remove": {
          "products": [
            {
              "id": (itemCart.id).toString(),
              "name": (itemCart.name).toString(),
              "price": itemCart.price,
              "brand": "Экспресс суши",
              "category": itemCart.category,
              "quantity": itemCart.quantity
            }
          ]
        }
      }
    });

    return true;
  }

  function purchase(order) {
    /**
     * @var Array<Object> _itemsCart:
     * [{ "id": string,
     *  "name": string,
     *  "price": number,
     *  "brand": string,
     *  "category": string,
     *  "variant": string,
     *  "quantity": number
     * }]
     *
     */
    var _itemsCart = order.cart;
    dataLayer.push({
      "ecommerce": {
        "currencyCode": "RUB",
        "purchase": {
          "actionField": {
            "id": order.id
          },
          "products": _itemsCart
        }
      }
    });

    return true;
  }

  return {
    init: init,
    dataLayer: _dataLayer,
    reachGoal: reachGoal,
    addToCart: addToCart,
    removeFromCart: removeFromCart,
    purchase: purchase,
  };

})(); // => END metrikaService

window.addEventListener('load', function(){
  metrikaService.init();
});
var order = (function(){
  var
    $cart = cookie.getCart(),
    $form = $('.order-form'),
    _orderBtnSubmit = $form.find('[type="submit"]');

  function init() {
    $form.addClass('needs-validation');
    _loadValue();
    _setUpListners();
    _onlyDelivery();
  }

  function _setUpListners() {
    $form.on('submit', _submit);
    $form.on('keydown change input', "input, textarea", _removeError);
    $form.find('.cookie').on('change keyup blur', _saveValue);
  }

  function _submit(e) {
    // e.preventDefault();
    $form.addClass('was-validated');

    var
      _validInput = validationForm($form, _orderBtnSubmit, true);

    if (_validInput) {
      return _orderBtnSubmit
        .addClass('disabled')
        .addClass('in-progress');
    } else {
      _orderBtnSubmit
        // .addClass('disabled')
        .parent()
          .find('.invalid-feedback')
          .show();
      return false;
    }

    // console.log('submit!');
    // return false;
  }

  function _saveValue(e) {
    var
      name = e.target.name,
      val = e.target.value;
    storage.set(name, val);
  }

  function _getSavedValue(name) {
    var _data = storage.get(name);
    if( _data === undefined) {
      return false;
    }
    return _data;
  }

  function _loadValue() {
    $form.find('.cookie').each(function(id, item){
      var
        _name = $(item).attr('name'),
        _data = _getSavedValue(_name);
      if(_data) {
        $(item).val(_data);
      }
    });
  }

  // Удаляет подсветку ошибок
  function _removeError() {
    var _validInput = validationForm($form, _orderBtnSubmit, true);
    if (_validInput) {
      _orderBtnSubmit
        .parent()
          .find('.invalid-feedback')
          .hide();

      _orderBtnSubmit.prop("disabled", false);
    }

    $(this).removeClass("form__error");
    $(this).parent().find('label').removeClass("form__error");
  }

  function _onlyDelivery() {
    var
      _warehouse = $('[name="obtaining_method"][value="1"]'),
      _warehouseWrap = _warehouse.parents('[data-toggle="collapse"]'),
      _warehouseHelp = $('#warehouseHelp'),
      $delivery_only = false;

    $('.basket-item ._amount').each(function(){
      if($(this).attr('data-delivery') == '1') {
        $delivery_only = true;
      }
    });

    _warehouseWrap.prop('disabled', $delivery_only);
    _warehouse
      .prop('required', !$delivery_only)
      .prop('disabled', $delivery_only);

    if($delivery_only) {
      _warehouseWrap.addClass('disabled');
      _warehouseHelp.css({opacity: 1}).html('Недоступно. В корзине есть товары только на доставку');
    } else {
      _warehouseWrap.removeClass('disabled');
      _warehouseHelp.html('');
    }

    $('.disabled').off('click');
    // console.log('Доставка:', $delivery_only);
  }

  return {
    init: init,
    delivery: _onlyDelivery
  };

})(); // => END module order

$(function() {
  // Заказ
  if($('.order-form').length) {
    order.init();
  }
});
// Модал заказ обратного звонка
var recall = (function(){
  var
    backdrop = $('<div class="modal-backdrop"></div>'),
    modal = $('#modalRecall'),
    modalForm = modal.find('form'),
    modalBody = modal.find('.modal-body__inner'),
    modalBtnSubmit = modalForm.find('[type="submit"]'),
    modalMessage = modal.find('.message');

  function init() {
    _setUpListners();
  }

  function _setUpListners() {
    modal.find('form').on('submit', _submit);
    modal.on('keydown change', "input, textarea", _removeError);
  }

  // Показ модального окна при отправке сообщения
  function _show(e) {
    e.preventDefault();

    modalMessage.html('');
    modalForm.show();

    modal.find('.modal-dialog').addClass("custom-width");
    modal.addClass('in').show();

    $('body').addClass('modal-open');
  }

  function _close(e) {
    e.preventDefault();
    modal.removeClass('in').hide();
    $('body').removeClass('modal-open');
  }

  function _submit(e){
    e.preventDefault();
    var
      validInput = validationForm(modalForm),
      url = modalForm.attr("action"),
      type = modalForm.attr("method"),
      data = modalForm.serialize();

    if (validInput) {
      modalBtnSubmit.prop("disabled",true)
      .val('Отправка...')
      .addClass('progress');

      sendData(data, url, type)
      .done(function (ans) {
        var mess = '<div class="alert alert-success" role="alert"><p align="center">Ваше сообщение отправлено</p></div>';
        if ( ans.status != 'success' ) {
          mess = ans.message;
          modalForm.hide();
        };
        modalMessage.html(mess);
        _clear(modalForm);
        modalForm.hide();

        setTimeout(function () { 
          modal.find('.close').trigger('click'); 
        }, 6000);
      })
      .fail(function () {
        var mess = '<div class="alert alert-danger">Проблемы на стороне сервера</div>';
        modalMessage.html(mess);
        _clear(modalForm);

        modalBtnSubmit.prop("disabled",false)
        .val('Заказать звонок')
        .removeClass('progress');
      })
      .always(function () {
        modalBtnSubmit.prop("disabled",false)
        .val('Заказать звонок')
        .removeClass('progress');
      });
    } else {
      return false;
    }
  }

  // Удаляет подсветку ошибок
  function _removeError() {
    $(this).removeClass("form__error");
    $(this).parent().find('label').removeClass("form__error");
    modalBtnSubmit.prop("disabled",false);
  }

  // Очистка формы
  function _clear(form) {
    form.trigger("reset");
    form.find("input, textarea, label").removeClass("form__error").removeClass("form__success");
    // $('input, textarea').placeholder();
  }

  return {
    init: init
  };

})(); // => END module recall
var
shopSelected,
shop = (function(){
  var
    _chooseShopBtn = $('.choose-shop')
    _modal = $('#selectShop'),
    _insertPlace = $('.select-shop-status');

  function init() {
    _setUpListners();
    _insertDataSelected();
  }

  function _setUpListners() {
    _chooseShopBtn.on('click', _choose);
    _modal.on('show.bs.modal', function (event) {

      // _modal.addClass('show');
      _modal.show();

      var button = $(event.relatedTarget);
      console.log('active button', button);
      var _tagcategoryID = button.data('tagcategory');

      _badge(_tagcategoryID);

      _modal.on('click', '.close', function(){
        _modal.modal('hide');
      });
    });

    _modal.on('shown.bs.modal', function () {
      _badgeStyles();
      if(!_modal.hasClass('show')) {
        _modal.addClass('show');
      }
    });
  }

  function _getSelectedId() {
    var _id = cookie.getShop();
    if (_id == 0) {
      if($('[name="shops_id"]').val() === undefined || $('[name="shops_id"]').val() === '') {
        // console.log('SelectedId', _id);
      } else {
        _id = parseInt($('[name="shops_id"]').val());
      }
    }
    return _id;
  }

  function _getSelected() {
    return sendData(
      'selected=true&req=' + Date.now(),
      '/api/v1/shop',
      'GET'
    )
      .done(function(data) {
        return data;
      })
      .fail(function () {
        return {};
        // var mess = '<div class="alert alert-danger">Проблемы на стороне сервера</div>';
        // modalMessage.html(mess);
      });
  }

  function _insertDataSelectedHtml(_shop) {
    var _tmpSelected = $('<a href="#selectShop" class="text-white" data-toggle="modal" data-target="#selectShop" title="Изменить свой выбор"><b class="_title"></b> <br class="d-block d-sm-none">(<b class="_address"></b>) <i class="fa fa-pencil"></i></a><br><span class="small">Режим работы:&nbsp;<span class="_timework"></span></span><br><span class="small">Время приема предзаказа:&nbsp;<span class="_timeorder"></span></span>');
    _tmpSelected.attr('data-select-shop', _shop.id).data('selectShop', _shop.id);
    _tmpSelected.find('._title').html(_shop.title);
    _tmpSelected.find('._address').html(_shop.address);
    _tmpSelected.find('._timework').html(_shop.timework);
    _tmpSelected.find('._timeorder').html(_shop.timeorder);
    _insertPlace.html(_tmpSelected);
  }

  function _insertDataSelected(_shop) {
    var
      _tmpDefault = '<button type="button" class="btn btn-sm btn-primary text-uppercase __select-shop" data-toggle="modal" data-target="#selectShop" aria-describedby="selectShopHelp">Выберите суши-бар</button>';
    if(_insertPlace.length) {
      if (_getSelectedId() == 0) {
        _insertPlace.html(_tmpDefault);
      }
      else {
        if (_shop === undefined) {
          $.when( shopSelected = _getSelected() )
            .done(function(){
              _shop = shopSelected.responseJSON;
              // console.log('selectedShop', _shop);
              _insertDataSelectedHtml(_shop);
            });
        } else {
          // console.log('selectedShop', _shop);
          _insertDataSelectedHtml(_shop);
        }
      }
    }
  }

  function _choose(e) {
    var
      _target = $(this),
      _selectId = _target.data('shopid'),
      _refresh = _target.data('refresh'),
      _data = JSON.stringify({
        id: _selectId,
        selected: true,
        req: Date.now()
      });

    if(_refresh==undefined) {
      e.preventDefault();
      _refresh = false;
    }

    _chooseShopBtn.prop('disabled', true);
    _target.addClass('in-progress');

    sendData(
      _data,
      '/api/v1/shop?req=' + Date.now(),
      'PUT'
    ).done(function(data) {
      console.log('selectShop', data);
      if (storage !== undefined) {
        storage.set('selectShop', JSON.stringify(data));
      } else {
        localStorage.setItem('selectShop', JSON.stringify(data));
      }
      cookie.setShop(data.id);
      _modal.modal('hide');
      _insertDataSelected(data);

      basket.update();
    })
    .fail(function () {
      // var mess = '<div class="alert alert-danger">Проблемы на стороне сервера</div>';
      // modalMessage.html(mess);
    })
    .always(function () {
      _chooseShopBtn.prop('disabled', false)
        .removeClass('in-progress');
    });

    return _refresh;
  }

  function _showMap() {
    var _map;
    $('#mapShops').css({ height: 450 }).hide();
    function init () {
      var _map = new ymaps.Map("mapShops", {
        center: [54.985097819556316, 73.35857632528676],
        zoom: 11,
        // type: "yandex#satellite",
        controls:['zoomControl']
      }, {
        suppressMapOpenBlock: true
      }),
      objectManager = new ymaps.ObjectManager({
        // Чтобы метки начали кластеризоваться, выставляем опцию.
        clusterize: false,
        // ObjectManager принимает те же опции, что и кластеризатор.
        gridSize: 32,
        clusterDisableClickZoom: true
      });
      _map.behaviors.disable('scrollZoom');
      // objectManager.objects.options.set('preset', 'islands#redDotIcon');
      // objectManager.clusters.options.set('preset', 'islands#redClusterIcons');
      objectManager.objects.options.set('iconLayout', 'default#image');
      // objectManager.objects.options.set('iconImageHref', '/assets/front/img/esushi-logo-icon-48x48.png');
      objectManager.objects.options.set('iconImageHref', '/assets/front/img/favicon.svg');
      objectManager.objects.options.set('iconImageSize', [42, 42]);
      objectManager.objects.options.set('iconImageOffset', [-21, -42]);
      _map.geoObjects.add(objectManager);

      $.ajax({
        url: "/api/v1/shops?map=true&req=" + Date.now(),
        dataType: "json"
      }).done(function(data) {
        objectManager.add(data);
      });

    }

    // $('#mapShops').slideDown('fast', function(){
    //   ymaps.ready(init);
    // });

    (async() => {
      do {
        if(typeof ymaps == 'object') {
          $('#mapShops').slideDown('fast', function(){
            ymaps.ready(init);
          });
        }
      } while (!window.hasOwnProperty("ymaps"));
    })();
  }

  function _badgeStyles() {
    $bootstrapColorVariables = [
      'primary',
      'secondary',
      'success',
      'danger',
      'warning',
      'info',
      // 'light',
      // 'dark',
    ];

    $('.badge-tag').removeClass('badge-primary');

    $('._filter .badge-tag').each(function(){
      var
        _self = $(this),
        _href = _self.attr('href');

      if(_href !== undefined) {
        var _tagcategoryID = _href.split('#tagcategory_')[1];

        if(_tagcategoryID !== '0') {
          var _badgeColor = getRandomInt(0, $bootstrapColorVariables.length - 1);
          $('.badge-tag[href="#tagcategory_' + _tagcategoryID + '"]').addClass('badge-' + $bootstrapColorVariables[_badgeColor]);
        }
      }
    });
  }

  function _badge(_tagcategoryID) {
    // console.log('Active badge-tag', _tagcategoryID);
    $('.badge-tag').removeClass('active');
    $('#selectShop .select-shop').removeClass('d-none');
    $('.select-shop_category').removeClass('d-none');

    if(_tagcategoryID !== '0') {
      var _target = $('.badge-tag[href="#tagcategory_' + _tagcategoryID + '"]');
      if(_target.length > 0) {
        _target.addClass('active');
        var _notTarget = $('#selectShop .select-shop').not($('.badge-tag[data-tagcategory="' + _tagcategoryID + '"]').parents('.select-shop'));
        _notTarget.addClass('d-none');

        var _categoryNotTarget = _notTarget.parents('.select-shop_category');
        _categoryNotTarget.each(function(){
          if($(this).find('.select-shop').length == $(this).find('.select-shop.d-none').length) {
            $(this).addClass('d-none');
          }
        });
      }

      // console.log(_categoryNotTarget);
    } else {
      $('#selectShop .select-shop').removeClass('d-none');
      $('.select-shop_category').removeClass('d-none');
    }
  }

  return {
    init: init,
    map: _showMap,
    badge: _badge
  };
})(); // => END shop

$(function() {
  // Выбор магазина
  if($('#selectShop').length || $('.select-shop-status').length) {
    shop.init();
  }
  // Показываем карту
  if ($('.l-shops').length > 0) {
    shop.map();
  }

  $('.badge-tag').on('click', function(e) {
    e.preventDefault();
    var
      _self = $(this),
      _href = _self.attr('href'),
      _tagcategoryID = _href.split('#tagcategory_')[1];

      shop.badge(_tagcategoryID);

      return false;
  });
});
var
storage = (function(){

  function set(_key, _val) {
    _key = _keyPrefix(_key);
    return localStorage.setItem(_key, _val);
  }

  function get(_key) {
    _key = _keyPrefix(_key);
    return localStorage.getItem(_key);
  }

  function getAll() {
    var _out = {};
    for (var i=0; i<localStorage.length; i++) {
      var key = localStorage.key(i);
      _out[key] = get(key);
    }
    return _out;
  }

  function remove(_key) {
    _key = _keyPrefix(_key);
    return localStorage.removeItem(_keyPrefix(_key));
  }

  function clear() {
    return localStorage.clear();
  }

  function _keyPrefix(_key) {
    var _prefix = ($storagePrefix !== undefined) ? $storagePrefix + '_' : '';
    return _prefix + _key;
  }

  return {
    set: set,
    get: get,
    getAll: getAll,
    remove: remove,
    clear: clear
  };
})(); // => END storage
var
widgetCart = (function () {

  var cartCookie;

  function init() {
    _loadWidget();
    _setUpListners();
  }

  function _setUpListners() {
    $('.cart-trigger').on('click', _collapseWidget);
  }

  function _collapseWidget() {
    var self = $('.cart-trigger'),
      cartList = $(".cart_list_wrap");
    cartList.slideToggle(400, 'easeOutQuad', function() {
      if (cartList.hasClass('open')){
        self.removeClass('open');
        cartList.removeClass('open');
      } else {
        self.addClass('open');
        cartList.addClass('open');
      }
    });

    _scrollOrderList();

    return true;
  }

  function _insertItemTmpl(item){
    var base_url = ($base_url !== undefined)? $base_url: '';
    // Шаблон одной позиции в выпадающем списке
    // item.cat != 6 -- не из категории "Упаковка и прочее"
    if ( item.cat != 6 && item.a > 0 ) {
      var itemId = $('#' + item.id),
        ps = 1,
        pp = 1,
        p = item.p;

      if ( itemId.length > 0 ) {
        p = parseInt( itemId.data('price') );
        ps = itemId.data('porstep');
        pp = itemId.data('porpack');
      }

      // var _imageUrl = base_url +'/nom/images/'+ item.id; // картинка по artikul_id
      var _imageUrl = base_url +'/nom/images/0/'+ item.nid +'/thumb'; // картинка по nomenclature_id
      // var _titleUrl = base_url +'/nom/title/'+ item.id +'/0'; // название по artikul_id
      var _titleUrl = base_url +'/nom/title/'+ item.id +'/'+ item.nid; // название по nomenclature_id

      return '<li class="cart-item" id="in_cart_'+ item.id +'" data-nomid="'+ item.nid +'" data-amount="'+ item.a +'" data-shopid="'+ item.sid +'" style="display:none;">'+
        '<button type="button" class="calc delete" data-operand="minus" data-artikul="'+ item.id +'" title="Удалить из корзины">×</button>'+
        '<span class="picture"><img title="" alt="" src="'+ _imageUrl +'"></span>'+
        '<i class="_name"><iframe frameborder="0" charset="utf-8" width="165" height="35" scrolling="no" src="'+ _titleUrl +'"></iframe></i>'+
        '<b class="_mask">&nbsp;</b>'+
        '<i class="_amount">x <span class="am">'+ parseInt(item.a) +'</span></i>'+
        '<i class="_price"><span class="tp">'+ (p * parseInt(item.a)) +'</span> <i class="fa fa-rub text-small"></i></i>'+
        '</li>';
    } else {
      return false;
    }
  }

  function _createItem(item) {
    $(".cart_list_scroller ._items")
      .append(_insertItemTmpl(item));
    $("#in_cart_" + item.id).slideDown('fast');

    _updateTotalTmpl($total);
  }

  function _deleteItem(inCartId) {
    inCartId
      .not('._pack')
      .slideUp('fast', function(){
        inCartId.remove();
        if ( $(".cart-item").length === 0 ) {
          $("#packing_item")
            .slideUp('fast',function(){
              $(this).remove();
            });
        };

        order.delivery();

        if ( $('.basket-items .basket-item').length == 0 && $('#cart').length == 0 ) {
          // console.log('basket empty');
          setTimeout(function(){
            document.location.href = '/';
          }, 1000);
        }
      });
    _updateTotalTmpl($total);
  }

  function _updateItem(inCartId, item) {
    inCartId.find(".am").html( parseInt(item.a) );
    inCartId.find(".tp").html( item.p * ( parseInt( item.a ) ) );
    inCartId.find(".b-units-input_amount").html( parseInt(item.a) );

    _updateTotalTmpl($total);
  }

  //Шаблон ИТОГО в выпадающем списке
  function _updateTotalTmpl(total) {
    if(parseInt($minOrderCashBack) > 0) {
      $('._cashback').text( 0 );
      $('._cashback_descr').html('(кэшбэк начисляется при заказе <span class="text-primary">от '+ $minOrderCashBack +'р.</span>)');
    }
    if(total.price > 0 && total.price < parseInt($minOrderCashBack)) {
      $('._cashback').text( parseFloat( total.price * .05 ).toFixed(2) );
      $('._cashback_descr').html('(при наличии бонусной карты – <a class="text-primary" href="/cashback" target="_blank" rel="nofollow">как получить?</a>)');
    }
    if ( total.price >= parseInt($minOrderCashBack) ) {
      $('._cashback').text( parseFloat( total.price * .1 ).toFixed(2) );
      $('._cashback_descr').html('(при наличии бонусной карты – <a class="text-primary" href="/cashback" target="_blank" rel="nofollow">как получить?</a>)');
    }
    // else {
    //   if(parseInt($minOrderCashBack) > 0) {
    //     $('._cashback').text( 0 );
    //     $('._cashback_descr').html('(кэшбэк начисляется при заказе <span class="text-primary">от '+ $minOrderCashBack +'р.</span>)');
    //   }
    // }

    _updateTotal(total);
  }

  function _updateTotal(total) {
    $(".cart ._to_pay, .total_to_pay").html(total.price);
    $("#current_order").val(total.price);
  }

  function _scrollOrderList() {};

  function _loadWidget() {
    // return loadWidget();
    var
      cartShow = false,
      cart = cookie.getCart();
    if (isEmpty(cart)) {
      $.cookie('cart', null, { expires: -1, path: '/' });
    }

    $.when( packingStatus.check() ).done(function(){
      cart = cookie.getCart();
      $total = calculateCart(cart);
    });

    if ( !isEmpty(cart) ){
      $cartlist.html('');

      $.each(cart, function(nid, item){
        // item.cat != 6 -- не из категории "Упаковка и прочее"
        // console.log(item);
        if ( item.s && item.cat != 6 ) {
          var _t = $(".menu-item #" + item.id),
            _ps = _t.data('porstep'),
            _pp = _t.data('porpack'),
            _a = parseInt( item.a );
          $(".menu-item #" + item.id)
            .val(_a) // обновляем значение в поле выбора
            .attr('data-amount', _a )
            .data('amount', _a );
          $cartlist.append( _insertItemTmpl(item) );
          cartShow = true;
        }
      });

      _updateTotalTmpl($total.price + delivery);

      if (cartShow) {
        $.when( _showWidget($total) ).done(function(){
          setTimeout(function(){
            _collapseWidget();
          }, 100);
        });
      }
    }
  }

  function _showWidget(total) {
    _updateTotalTmpl(total);
    $widget.fadeIn();
    $('.cart-item').slideDown(700, function() { _scrollOrderList(); });
    setTimeout(function(){ _collapseWidget(); }, 1400);
  }

  function _hideWidget(){
    $("#total_pay_item").slideUp('fast',function(){
      $("#total_pay_item").remove();
    });

    $(".cart_list_wrap").slideUp('fast', 'easeOutQuad', function() {
      _collapseWidget();
      $("#cart_layer").fadeOut('fast');
    });

    $("#packing_item").remove();
    $('#delivery_item').remove();
    $widget.fadeOut('fast');
  }

  return {
    init: init,
    createItem: _createItem,
    updateItem: _updateItem,
    deleteItem: _deleteItem,
    updateTotal: _updateTotal,
    show: _showWidget,
    hide: _hideWidget
  };

})(); // => END widgetCart